module.exports = __webpack_public_path__ + "img/3_52.d43b28b3.png";